module.exports = __webpack_public_path__ + "static/mapkins-machine-zoom-54a945ba8dae59148cdf86972ef0be4e.jpg";